import React from 'react';

import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: 'totalQuantity',
  type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
  filterValue: 'Quantity',
  displayName: <FormattedMessage {...messages.quantity} />,
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_NUMBER_COMPARISON, criteriaInformations);
  },
};
